<template>
	<section v-if :class="topPanel ? 'top-panel-recent' : 'right-col-panel'">
		<product-list-recent-item v-for="(product, index) in products" :key="product.id" :product="product" @click.native="clicked(product, index)" />
	</section>
</template>
<script>
import { mapGetters } from 'vuex';
import store from 'datastore';
import { trackImpression } from 'gtm';

export default {
	props: {
		thumbProducts: {
			type: Array,
			required: false,
			default: () => [],
		},
		topPanel: {
			type: Boolean,
			default: false,
			required: false,
		},
		campaign: {
			type: Object,
			default: () => {},
			required: false,
		},
		compactCarousel: {
			type: Boolean,
			default: false,
			required: false,
		},
		productPage: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	store,
	data () {
		return {
			recentProducts: [],
			topView: [],
			currentRoute: null,
		};
	},
	methods: {
		clicked (product, index) {
			trackImpression([product], 'Senast visade', { event: 'select_item', position: index });
		},
	},
	computed: {
		products () {
			return this.thumbProducts;
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
	mounted () {
		this.currentRoute = this.$route.name;
	},
};
</script>
